import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { P3Campaign } from 'models/interfaces/index';
import { P3Configuration } from 'models/interfaces/P3Configurations';
import { ApolloClient } from 'apollo-client';

export const GET_CLIENT_P3_CAMPAIGN_MODULE = gql`
  query GetP3CampaignModule {
    campaignModule @client {
      p3_campaign_id
      name
      p3_configuration_id
      tgrams_id
      p3_configuration {
        p3_configuration_id
        p3_campaign_id
        configuration_status_id
        tgrams_id
        name
        description
        rank_points
        coverage_areas
        preview_ads
        program_value
        start_date
        end_date
        categories {
          p3_configuration_id
          category_id
          category_name
          national_purchased_rank_points
          national_total_rank_points
          national_estimated_rank
          regional_purchased_rank_points
          regional_total_rank_points
        }
        regions {
          p3_configuration_id
          region_code
          name
          estimated_rank
        }
      }
      advertiser {
        name
        tgrams_id
      }
      entitled_rank_points
      entitled_coverage_areas
      entitled_preview_ads
      start_date
      end_date
    }
  }
`;

export const GET_P3_CAMPAIGN_TEMPLATES_QUERY = gql`
  query GetP3CampaignTemplates($p3_campaign_id: String!, $tgrams_id: String!) {
    p3Campaign(p3_campaign_id: $p3_campaign_id) {
      p3_campaign_id
      name
      p3_configuration_id
      entitled_rank_points
      entitled_coverage_areas
      entitled_preview_ads
      start_date
      end_date
      p3_configuration {
        p3_configuration_id
        p3_campaign_id
        configuration_status_id
        tgrams_id
        description
        name
        rank_points
        coverage_areas
        preview_ads
        program_value
        start_date
        end_date
        categories {
          p3_configuration_id
          category_id
          category_name
          national_purchased_rank_points
          national_total_rank_points
          national_estimated_rank
          regional_purchased_rank_points
          regional_total_rank_points
        }
        regions {
          p3_configuration_id
          region_code
          name
          estimated_rank
        }
      }
    }
    templates: thomasTemplatesForCampaign(tgrams_id: $tgrams_id) {
      p3_configuration_id
      p3_campaign_id
      configuration_status_id
      tgrams_id
      description
      name
      rank_points
      coverage_areas
      preview_ads
      program_value
      last_updated_date
      last_updated_by
      created_date
      start_date
      end_date
      categories {
        p3_configuration_id
        category_id
        category_name
        national_purchased_rank_points
        national_total_rank_points
        national_estimated_rank
        regional_purchased_rank_points
        regional_total_rank_points
      }
      regions {
        p3_configuration_id
        region_code
        name
        estimated_rank
      }
    }
  }
`;

export const SAVE_P3_CAMPAIGN_MUTATION = gql`
  mutation SaveCampaign($campaign: P3CampaignInput) {
    saveP3Campaign(campaign: $campaign) {
      p3_campaign_id
      tgrams_id
      name
      p3_configuration_id
      entitled_rank_points
      entitled_coverage_areas
      entitled_preview_ads
      start_date
      end_date
      last_updated_by
      last_updated_date
      created_by
      created_date
    }
  }
`;

export const PUBLISH_P3CAMPAIGN_MUTATION = gql`
  mutation PublishP3Campaign($p3CampaignId: String!) {
    publishP3Campaign(p3_campaign_id: $p3CampaignId)
  }
`;

export const DELETE_P3_CAMPAIGN_MUTATION = gql`
  mutation DeleteP3Campaign($campaign_id: string) {
    deleteP3Campaign(campaign_id: $campaign_id)
  }
`;

interface P3CampaignContainerRenderProps {
  p3Campaign: P3Campaign;
  templates: P3Configuration[];
  updateCampaignModule: (data: P3Campaign) => any;
  client: ApolloClient<any>;
}

interface P3CampaignContainerResults {
  p3Campaign: P3Campaign;
  templates: P3Configuration[];
}
interface P3CampaignContainerProps {
  p3_campaign_id: String;
  tgrams_id: String;
  children: (props: P3CampaignContainerRenderProps) => any;
}

const P3CampaignContainer: React.FunctionComponent<P3CampaignContainerProps> = ({
  p3_campaign_id,
  tgrams_id,
  children,
  ...props
}) => (
  <Query<P3CampaignContainerResults>
    query={GET_P3_CAMPAIGN_TEMPLATES_QUERY}
    fetchPolicy={'network-only'} // req. b/c cache stores initial null res when creating a new campaign
    variables={{ p3_campaign_id, tgrams_id }}
  >
    {({
      data: { p3Campaign, templates } = {
        p3Campaign: {} as P3Campaign,
        templates: [] as P3Configuration[]
      },
      loading,
      client
    }) => {
      if (loading) {
        return null;
      }
      // create a new p3Campaign campaign if this one's empty
      if (p3Campaign === null) {
        p3Campaign = {} as P3Campaign;
      }
      // create empty array if there are no templates
      if (!templates || templates.length === 0) {
        templates = new Array<P3Configuration>();
      }

      return (
        children &&
        children({
          ...props,
          p3Campaign,
          templates,
          updateCampaignModule: (campaignModule: any) => {
            console.log(`save campaignModle in cache`, campaignModule);
            return client.writeData({ data: { campaignModule } });
          },
          client
        })
      );
    }}
  </Query>
);

export default P3CampaignContainer;
